import { SprintStageDTO } from "../interfaces/ClassesDTO";
import { RaceDTO } from "../interfaces/RaceDTO";
import { ViewType } from "../interfaces/internal/ViewProps";


export const getMenuUpSet = (race:RaceDTO | null):ViewType[] => {
    
   if (!race){
    return [];
   }
   let isSprint = false;
   let vTyp:ViewType[] = [];
   if (race.Sport !== "BT"){
    vTyp.push(ViewType.shooting);
   }
   Object.keys(race.Class).map((ind) => {
      if (race.Class[parseInt(ind)].StageType !== SprintStageDTO.noSprint){
        isSprint = true;
      }
   });
   if (!isSprint){
    vTyp.push(ViewType.stage);
   }

    return vTyp;
};

export const showMenuChoice = (race:RaceDTO | null, vTyp:ViewType):boolean =>{
    if (race === null){
        return true;
    }
      
    return !getMenuUpSet(race).includes(vTyp);
};